<template>
<div class="modalContents__object13" data-modalContents="mypage">
    <div class="container">
        <div class="row no-gutters">
            <div class="col-xl-6 col-lg-8 col-md-11 col-12 mx-auto">
                <h2 class="text-center">MEMBERSHIP INFO.</h2>
                <form class="row no-gutters">
                    <div class="modalContents__object13__btn">
                        <a href="javascript:void(0)" class="globalModal--btn" data-modal="mypageClose" title="close" @click='hideModal'>
                            <span class="fa-stack fa-lg">
                                <i class="fa fa-circle-thin fa-stack-2x fa-inverse" aria-hidden="true"></i>
                                <i class="fa fa-times fa-stack-1x fa-inverse" aria-hidden="true"></i>
                            </span>
                        </a>
                    </div>
                    <h3 class="col-12">■ 登録者情報</h3>
                    <dl class="col-12 row no-gutters">
                        <dt class="col-3">お名前</dt>
                        <dd class="col-9">{{ $store.state.userData.last_name }} {{ $store.state.userData.first_name }}</dd>
                        <dt class="col-3" v-if="!social_login">MAIL</dt>
                        <dd class="col-9" v-if="!social_login">{{ $store.state.userData.email }}</dd>
                        <dt class="col-3">TEL</dt>
                        <dd class="col-9">{{ $store.state.userData.phone }}</dd>
                        <dt class="col-3" v-if="!social_login">パスワード</dt>
                        <dd class="col-9" v-if="!social_login">＊＊＊＊＊＊＊＊＊＊</dd>
                        <dt class="col-3">生年月日</dt>
                        <dd class="col-9">{{ dispBirthday() }}</dd>
                        <dt class="col-3">性別</dt>
                        <dd class="col-9">{{ dispGender() }}</dd>
                    </dl>
                    <div class="col-sm-3 offset-sm-9 col-4 offset-8">
                        <button class="text-center btn modalContents__object13--change globalModal--btn" data-modal="mypageChange01"
                            type="submit" @click="changePersonal">変更</button>
                    </div>
                    <h3 class="col-12">■ プラン内容</h3>
                    <dl class="col-12 row no-gutters">
                        <dt class="col-3">視聴プラン</dt>
                        <dd class="col-9">{{ dispPlan() }}</dd>
                        <dt class="col-3">メールマガジン</dt>
                        <dd class="col-9">{{ $store.state.userData.mm01 ? '「ニッポンの問題点」を購読' : '' }}</dd>
                        <dt class="col-3">メールマガジン</dt>
                        <dd class="col-9">{{ $store.state.userData.mm02 ? '「読むオプエド」を購読' : '' }}</dd>

                        <dt class="col-3" v-if="isbank && end">ご契約月数</dt>
                        <dd class="col-9" v-if="isbank && end">{{months}}ヶ月</dd>

                        <dt class="col-3" v-if="isbank && end">ご契約期限</dt>
                        <dd class="col-9" v-if="isbank && end">{{end}}まで</dd>
                    </dl>
                    <div class="col-sm-3 offset-sm-9 col-4 offset-8">
                        <button class="text-center btn modalContents__object13--change globalModal--btn" data-modal="mypageChange02"
                            type="submit" @click="changePlan">変更</button>
                    </div>
                    <div class="row no-gutters" style="width:100%" v-if="movies">
                        <h3 class="col-12">■ 購入履歴</h3>
                        <dl class="col-12 row no-gutters">
                            <dd class="col-12" v-for="movie in movies" v-bind="movies">
                                <a :href="getMovieUrl(movie)">{{ movie.title }}</a>
                                <a :href="getMovieUrl(movie)"><img :src="movie.movie_image_main" alt="" width="120" class='pull-right' style="padding-right: 10px;"></a>
                            </dd>
                        </dl>
                    </div>
                </form>
                
            </div>
        </div>
        
    </div>
</div>

</template>
<script>
  import { mapMutations } from 'vuex'
  import MultiModalMixin from '../mixins/ModalMixin'

  export default {
    name: "Mypagetop",
    mixins: [MultiModalMixin],
    data : function(){
        return {
            movies : OPED.movies,
            social_login:OPED.social_login,
            isbank:false,
            months:'',
            end:'',
        }
    },
    mounted: function(){
        if(OPED.login_user.new_order_type == 'bank'){
            this.isbank = true;
            this.months = OPED.login_user.new_order.bankmonth;
            this.end = OPED.login_user.expired_at;
        }
    },
    methods : {
      getMovieUrl (movie) {
          return '/video/' + movie.id;
      },
      dispBirthday () {
        return getBirthday(this.$store.state.userData.birthday);
      },
      dispGender(){
        return getGenderName(this.$store.state.userData.gender);
      },
      dispPlan(){
        let plan = this.$store.state.userData.plan;
        switch (plan) {
          case 0:
              return "ブロンズメンバー";
          case 1:
              return "シルバーメンバー";
          case 2:
              return "ゴールドメンバー";
          case 3:
              return "プラチナメンバー（サロン）";
        }
      },
      getPlanName(){
        let plan = this.$store.state.userData.plan;
        switch (plan) {
          case 0:
              return "bronze";
          case 1:
              return "shilver";
          case 2:
              return "gold";
          case 3:
              return "platinum";
        }
      },

      changePersonal(e){

        this.$store.state.inputData.last_name = this.$store.state.userData.last_name;
        this.$store.state.inputData.first_name = this.$store.state.userData.first_name;
        this.$store.state.inputData.phone = this.$store.state.userData.phone;
        this.$store.state.inputData.email = this.$store.state.userData.email;
        this.$store.state.inputData.birthday = this.$store.state.userData.birthday;
        this.$store.state.inputData.gender = this.$store.state.userData.gender;
        this.showModalMain();

        e.preventDefault();
      },

      changePlan(e){

        //this.$store.state.inputData.plan = this.getPlanName();
        //this.$store.state.inputData.mm01 = this.$store.state.userData.mm01;

        this.showModalPlan();

        e.preventDefault();
      },
    }
  };
</script>


// WEBPACK FOOTER //
// resources/assets/js/vue/component/modal/mypage_top.vue